import { cn } from '#app/utils/misc.tsx'

export function Gradient({
	className,
	...props
}: React.ComponentPropsWithoutRef<'div'>) {
	return (
		<div
			{...props}
			className={cn(
				className,
				'bg-[linear-gradient(115deg,var(--tw-gradient-stops))] from-purple-700 from-[28%] via-emerald-500 via-[70%] to-green-600',
			)}
		/>
	)
}

export function GradientBackground() {
	return (
		<div className="relative mx-auto max-w-7xl">
			<div
				className={cn(
					'md:right-90 absolute -right-20 -top-20 h-40 w-[20rem] transform-gpu sm:-right-40 sm:-top-32 sm:h-52 sm:w-[28rem] md:-top-44 md:h-60 md:w-[36rem]',
					'bg-[linear-gradient(115deg,var(--tw-gradient-stops))] from-[#fff1be] from-[28%] via-[#ee87cb] via-[70%] to-[#b060ff]',
					'rotate-[-10deg] rounded-full blur-3xl',
				)}
			/>
		</div>
	)
}
